export default "__VITE_ASSET__D3b4RN5$__"